import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

//
// Copyright IBM Corp. 2020, 2020
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tab, Tabs } from 'carbon-components-react';
import { settings } from 'carbon-components';
import { createInteractionHandler } from '../../component_helpers/A11yHelper';
import { idAttribute } from '../../component_helpers/IDHelper';
import { IdePageContent } from '../IdeNavigation';
import { IdeCard } from '../IdeCard';
import { renderGraphic } from '../../component_helpers/ReactHelper';
import { idePrefix } from '../../globals/js/settings';
var prefix = settings.prefix;

var IdeHome = /*#__PURE__*/function (_React$Component) {
  _inherits(IdeHome, _React$Component);

  var _super = _createSuper(IdeHome);

  function IdeHome() {
    var _this;

    _classCallCheck(this, IdeHome);

    _this = _super.call(this);
    _this.state = {
      currentSetIndex: 0,
      lastSetIndex: undefined
    };
    _this.handleSetChange = _this.handleSetChange.bind(_assertThisInitialized(_this));
    return _this;
  } // required to encapsulate the carbon selected tab logic, but offer the ability to be controlled by a parent for selected tab


  _createClass(IdeHome, [{
    key: "handleSetChange",
    value: function handleSetChange(setIndex) {
      this.setState({
        lastSetIndex: this.state.currentSetIndex,
        currentSetIndex: setIndex
      });
    } // Input an array of tasks and returns an array of cards

  }, {
    key: "createCardsFromTasks",
    value: function createCardsFromTasks(tasks) {
      return tasks.map(function (task) {
        var ideCardProps = {
          key: task.taskId,
          cardId: task.taskId,
          onInteract: task.onInteract,
          cardSize: task.cardSize,
          cardHref: task.cardHref,
          cardLinkTarget: task.cardLinkTarget,
          cardHeading: task.taskHeading,
          cardHeadingTitle: task.taskHeadingTitle,
          cardHeadingDescription: task.taskHeadingDescription,
          cardGraphic: task.taskGraphic,
          cardType: task.cardType ? task.cardType : task.renderFunc ? 'custom' : task.taskLinks ? 'link' : task.cardHref && task.cardLinkType == 'external' ? 'externalLink' : 'text',
          cardDisabled: task.disabled,
          cardContent: task.taskContent,
          disabledText: task.tooltipText,
          secondaryGraphic: task.secondaryGraphic
        };

        if (ideCardProps.cardType == 'custom') {
          ideCardProps.cardContent = {
            renderFunc: task.renderFunc
          };
        } else if (ideCardProps.cardType == 'link') {
          ideCardProps.cardContent = {
            links: task.taskLinks
          };
        }

        return /*#__PURE__*/React.createElement(IdeCard, _extends({}, ideCardProps, {
          key: ideCardProps.key
        }));
      });
    }
  }, {
    key: "renderSets",
    value: function renderSets(sets, currentSet, multipleSetType) {
      var _this2 = this;

      var setsToRender = []; // build each set with its tasks

      sets.forEach(function (set) {
        var setToRender = {
          id: set.id,
          heading: set.setHeading
        };

        if (set.tasks) {
          setToRender.tasks = _this2.createCardsFromTasks(set.tasks, set.id);
        } else {
          setToRender.renderFunc = function () {
            return set.renderFunc ? set.renderFunc() : /*#__PURE__*/React.createElement("div", null, "Default Content");
          };
        }

        setsToRender.push(setToRender);
      });
      var setsJSX = null;

      if (setsToRender.length > 1) {
        if (multipleSetType === 'tab') {
          // tabs case
          setsJSX = /*#__PURE__*/React.createElement(Tabs, _extends({
            selected: currentSet,
            className: "".concat(prefix, "--row"),
            tabContentClassName: "".concat(idePrefix, "-home-tab-content")
          }, idAttribute("IdeHome-Tabs")), setsToRender.map(function (set, index) {
            return /*#__PURE__*/React.createElement(Tab, _extends({
              id: "".concat(idePrefix, "-home-tab-content-").concat(set.id),
              key: set.id,
              label: set.heading
            }, idAttribute("IdeHome-Tab-".concat(set.id)), createInteractionHandler(function () {
              // on tab click/press, update the selected index
              _this2.handleSetChange(index);
            })), /*#__PURE__*/React.createElement("section", _extends({}, idAttribute('IdeHome-Task-Set'), {
              className: "".concat(prefix, "--row ").concat(idePrefix, "-home-full-width")
            }), set.tasks ? set.tasks : set.renderFunc()));
          }));
        }

        if (multipleSetType === 'section') {
          // sections case
          setsJSX = setsToRender.map(function (set) {
            return /*#__PURE__*/React.createElement("section", _extends({
              key: set.id
            }, idAttribute("IdeHome-Section-".concat(set.id)), {
              className: "".concat(prefix, "--row ").concat(idePrefix, "-home-full-width")
            }), set.heading && /*#__PURE__*/React.createElement("h3", _extends({}, idAttribute("IdeHome-Section-title-".concat(set.id)), {
              className: "".concat(idePrefix, "-home--section-title")
            }), set.heading), set.tasks ? set.tasks : set.renderFunc());
          });
        }
      } else if (setsToRender.length === 1) {
        // one set case
        setsJSX = /*#__PURE__*/React.createElement("section", _extends({}, idAttribute('IdeHome-Task-Set'), {
          className: "".concat(prefix, "--row ").concat(idePrefix, "-home-full-width")
        }), setsToRender[0].tasks ? setsToRender[0].tasks : setsToRender[0].renderFunc());
      }

      return /*#__PURE__*/React.createElement("div", _extends({}, idAttribute('IdeHome-Sets'), {
        className: "".concat(prefix, "--row ").concat(prefix, "--grid ").concat(prefix, "--grid--condensed ").concat(idePrefix, "-home-table")
      }), setsJSX);
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
          multipleSetType = _ref.multipleSetType,
          headerCollapsed = _ref.headerCollapsed,
          headerCollapsible = _ref.headerCollapsible,
          headerButtonTextCollapse = _ref.headerButtonTextCollapse,
          headerButtonTextExpand = _ref.headerButtonTextExpand,
          headerHandleCollapseFunc = _ref.headerHandleCollapseFunc,
          headerOne = _ref.headerOne,
          headerTwo = _ref.headerTwo,
          headerGraphic = _ref.headerGraphic,
          sets = _ref.sets,
          className = _ref.className,
          others = _objectWithoutProperties(_ref, ["multipleSetType", "headerCollapsed", "headerCollapsible", "headerButtonTextCollapse", "headerButtonTextExpand", "headerHandleCollapseFunc", "headerOne", "headerTwo", "headerGraphic", "sets", "className"]);

      return /*#__PURE__*/React.createElement("section", _extends({}, idAttribute('IdeHome'), {
        className: "".concat(idePrefix, "-home ").concat(className)
      }, others), /*#__PURE__*/React.createElement(IdePageContent, null, /*#__PURE__*/React.createElement("div", _extends({}, idAttribute('IdeHome-Header'), {
        className: "".concat(headerCollapsed ? 'collapsed' : '', " ").concat(idePrefix, "-home-header ").concat(prefix, "--row")
      }), /*#__PURE__*/React.createElement("div", _extends({}, idAttribute('IdeHome-Header-Text'), {
        className: "\n                ".concat(idePrefix, "-home-heading-container\n                ").concat(prefix, "--col-sm-").concat(!headerCollapsible ? 1 : headerCollapsed ? 3 : 2, "\n                ").concat(prefix, "--col-md-").concat(!headerCollapsible ? 2 : headerCollapsed ? 6 : 3, "\n                ").concat(prefix, "--col-lg-").concat(!headerCollapsible ? 6 : headerCollapsed ? 14 : 6, "\n                ").concat(prefix, "--col-xlg-").concat(!headerCollapsible ? 6 : headerCollapsed ? 14 : 6, "\n                ").concat(prefix, "--col-max-").concat(!headerCollapsible ? 6 : headerCollapsed ? 14 : 6, "\n              ")
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "".concat(idePrefix, "-home-product-heading")
      }, headerOne), !headerCollapsed && /*#__PURE__*/React.createElement("p", {
        className: "".concat(idePrefix, "-home-call-to-action")
      }, headerTwo))), !headerCollapsed && /*#__PURE__*/React.createElement("div", _extends({}, idAttribute('IdeHome-Header-Image'), {
        className: "\n                  ".concat(idePrefix, "-home-image-container\n                  ").concat(prefix, "--col-sm-").concat(!headerCollapsible ? 3 : 2, "\n                  ").concat(prefix, "--col-md-").concat(!headerCollapsible ? 6 : 3, "\n                  ").concat(prefix, "--col-lg-").concat(!headerCollapsible ? 10 : 8, "\n                  ").concat(prefix, "--col-xlg-").concat(!headerCollapsible ? 10 : 8, "\n                  ").concat(prefix, "--col-max-").concat(!headerCollapsible ? 10 : 8, "\n                ")
      }), renderGraphic(headerGraphic)), headerCollapsible && /*#__PURE__*/React.createElement("div", _extends({}, idAttribute('IdeHome-header-toggle-container'), {
        className: "\n                  ".concat(idePrefix, "-home-header-toggle-container\n                  ").concat(prefix, "--col-sm-", 1, "\n                  ").concat(prefix, "--col-md-", 2, "\n                  ").concat(prefix, "--col-lg-", 2, "\n                  ").concat(prefix, "--col-xlg-", 2, "\n                  ").concat(prefix, "--col-max-", 2, "\n                ")
      }), /*#__PURE__*/React.createElement(Button, _extends({}, idAttribute('IdeHome-header-toggle'), {
        disabled: false,
        kind: "ghost",
        onClick: headerHandleCollapseFunc,
        renderIcon: undefined,
        size: "small",
        type: "button"
      }), headerCollapsed ? headerButtonTextExpand : headerButtonTextCollapse))), this.renderSets(sets, this.state.currentSetIndex, multipleSetType)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var derivedState = null; // check which set to render, if startSelected provided in any set

      var selectedSetIndex = props.sets.findIndex(function (set) {
        return set.startSelected === true;
      });

      if (selectedSetIndex !== -1 && selectedSetIndex !== state.lastSetIndex) {
        derivedState = {
          currentSetIndex: selectedSetIndex,
          lastSetIndex: state.lastSetIndex
        };
      }

      return derivedState;
    }
  }]);

  return IdeHome;
}(React.Component);

export { IdeHome as default };
IdeHome.propTypes = {
  /** An optional toggle text to use on the collapsible header button - for collapsing the header. */
  headerButtonTextCollapse: PropTypes.string,

  /** An optional toggle text to use on the collapsible header button - for expanding the header. */
  headerButtonTextExpand: PropTypes.string,

  /** An optional boolean flag which should be instantiated to false by the consumer so that the expanded banner is initially used. When this flag is provided the collapsible banner will be used by default. */
  headerCollapsed: PropTypes.bool,

  /** An optional boolean flag which should be instantiated to true by the consumer should they want the banner to be collapsible. */
  headerCollapsible: PropTypes.bool,

  /** Optional graphic properties. This graphic will be rendered alongside the header text. This can either be a react component, or the following shape*/
  headerGraphic: PropTypes.oneOfType([PropTypes.shape({
    /** link to the image to display */
    imgSrc: PropTypes.string.isRequired,

    /** Alt text for this image. Must be provided to be accessible, and must be pre translated */
    imgAlt: PropTypes.string.isRequired,

    /** Optional - css class to apply to this image */
    imgClassName: PropTypes.string
  }),
  /** A react component, with all props etc defined */
  PropTypes.element, PropTypes.object]),

  /** An optional callback function to call when the toggle is activated. */
  headerHandleCollapseFunc: PropTypes.func,

  /** Main header text. Must be pre translated */
  headerOne: PropTypes.string.isRequired,

  /** Secondary header text. Optional. Must be pre translated */
  headerTwo: PropTypes.string,

  /** The initial set to render on mount. Should be the id of the set you want to render first. If undefined, will render the first set provide */
  initialSet: PropTypes.string,

  /** How multiple sets are to be displayed - tab is default. */
  multipleSetType: PropTypes.oneOf(['section', 'tab']),

  /** Set of grouped activities or tasks. If more than one is provided options appear as tabs. */
  sets: PropTypes.arrayOf(PropTypes.shape({
    /** Unique id for this set of tasks */
    id: PropTypes.string.isRequired,

    /** Heading for this set of tasks. Must be pre translated */
    setHeading: PropTypes.string.isRequired,

    /** Optional - provide this if this set is to start selected. If multiple are provided, the last one wins. */
    startSelected: PropTypes.bool,

    /** The set of tasks */
    tasks: PropTypes.arrayOf(PropTypes.shape({
      /** Unique id for this task */
      taskId: PropTypes.string.isRequired,

      /** Card href - if the task represents a link, the url the card should refer too */
      cardHref: PropTypes.string,

      /** Card cardLinkType - if the task represents a link, whether the url should open in a new tab */
      cardLinkType: PropTypes.oneOf(['internal', 'external']),

      /** Card href target - if the task represents an external link then whether to specify a target */
      cardLinkTarget: PropTypes.string,

      /** Card size - standard is default */
      cardSize: PropTypes.oneOf(['standard', 'large']),

      /** Card size - standard is default */
      cardType: PropTypes.oneOf(['externalLink', 'node', 'link', 'text', 'custom']),

      /** renderFunc - optional - provide this to insert your own JSX content into a card. If provided, taskHeading, taskSubtext and taskGrpahic are not rendered ignored */
      renderFunc: PropTypes.func,

      /** Task graphic for this task. This can either be a react component, or the following shape */
      taskGraphic: PropTypes.oneOfType([PropTypes.shape({
        /** link to the image to display */
        imgSrc: PropTypes.string.isRequired,

        /** Alt text for this image. Must be provided to be accessible, and must be pre translated */
        imgAlt: PropTypes.string.isRequired,

        /** Optional - css class to apply to this image */
        imgClassName: PropTypes.string
      }),
      /** A react component, with all props etc defined */
      PropTypes.element]),

      /** Heading for this task. Used in aria markup for the tile, and as the heading if no render function is provided. Must be pre translated */
      taskHeading: PropTypes.string.isRequired,

      /** Heading title for this task. Used in aria markup for the tile, and as the heading if no render function is provided. Must be pre translated */
      taskHeadingTitle: PropTypes.string,

      /** Heading subtitle for this task. Used in aria markup for the tile, and as the heading if no render function is provided. Must be pre translated */
      taskHeadingDescription: PropTypes.string,

      /** Subtext for this task. Must be pre translated if provided */
      taskSubtext: PropTypes.string,

      /** Array of items to show as links */
      taskLinks: PropTypes.arrayOf(PropTypes.shape({
        /** translated text to show as link */
        text: PropTypes.string,

        /** href destination for the link */
        href: PropTypes.string
      })),

      /** Function which is fired on click/keypress of this tab */
      onInteract: PropTypes.func,

      /** Boolean flag to conditionally render a disabled card */
      disabled: PropTypes.bool,

      /** Tooltip to display on the link of a disabled card */
      tooltipText: PropTypes.string,

      /** Optional prop - set this to "external" to always display the launch out icon */
      secondaryGraphic: PropTypes.oneOf(['external'])
    })),

    /** A callback function that should return user defined JSX content that will be displayed under the tabs */
    renderFunc: PropTypes.func
  }))
};
IdeHome.defaultProps = {
  multipleSetType: 'tab',
  headerCollapsible: false,
  headerButtonTextExpand: 'Show more - CHANGE ME',
  headerButtonTextCollapse: 'Show less - CHANGE ME',
  headerOne: 'Product text',
  headerTwo: 'Call to action',
  headerGraphic: {},
  sets: []
};